module.exports = __webpack_public_path__ + "img/logo（酒专栏）.cd4c4fef.png";